import {api} from '~/ViewInvitation/api/api';
import {
  type GuestQueryArgs,
  type MutateQueryArgs,
  type MutateResponse,
  type Post,
  type PostsResponse,
  type ReplyQueryArgs,
  type ReplyResponse,
} from '~/ViewInvitation/types/api';

export const postsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPosts: builder.query<Post[], GuestQueryArgs>({
      query: ({eventId, guestId}) => ({
        url: `/services/event/v2/${eventId}/posts?gid=${guestId}`,
      }),
      providesTags: ['Posts'],
      transformResponse: (response: PostsResponse) => {
        return response.posts;
      },
    }),
    toggleLike: builder.mutation<MutateResponse, MutateQueryArgs>({
      query: ({eventId, postId, guestId}) => ({
        url: `/services/event/v2/${eventId}/posts/${postId}/toggle-like?gid=${guestId}`,
        method: 'POST',
      }),
      invalidatesTags: ['Posts'],
    }),
    reply: builder.mutation<ReplyResponse, ReplyQueryArgs>({
      query: ({eventId, postId, comment, guestId}) => ({
        url: `/services/event/v2/${eventId}/posts/${postId}/reply?gid=${guestId}`,
        method: 'POST',
        body: {
          comment,
        },
      }),
      invalidatesTags: ['Posts'],
    }),
    deleteComment: builder.mutation<{}, MutateQueryArgs>({
      query: ({eventId, postId, guestId}) => ({
        url: `/services/event/v2/${eventId}/posts/${postId}?gid=${guestId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Posts'],
    }),
    editComment: builder.mutation<ReplyResponse, ReplyQueryArgs>({
      query: ({eventId, postId, comment, guestId}) => ({
        url: `/services/event/v2/${eventId}/posts/${postId}?gid=${guestId}`,
        method: 'PUT',
        body: {
          comment,
        },
      }),
      invalidatesTags: ['Posts'],
    }),
  }),
});

export const {
  useGetPostsQuery,
  useToggleLikeMutation,
  useReplyMutation,
  useEditCommentMutation,
  useDeleteCommentMutation,
} = postsApi;
